import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

type BranchFilterProps = {
  selectedFranchises: number;
};

const BranchFilter = ({ selectedFranchises }: BranchFilterProps) => {
  const openModal = () => EventEmitter.emit(EVENT_TYPES.openModal, 'filters');

  return (
    <button
      className="ch-btn ch-width--12 ch-mv--2 ch-bc--grey-5 sm:ch-mv--0 sm:ch-ph--6 sm:ch-width--auto branch-filter-button ac__btn--new-focus"
      onClick={openModal}
      type="button"
    >
      Filter branches{' '}
      {selectedFranchises > 0 && (
        <span className="ch-color--ac-blue ch-pl--1">
          &#40;{selectedFranchises}&#41;
        </span>
      )}
    </button>
  );
};

export default BranchFilter;
